import React from 'react';
import './BookDetails.css'; // using same css as Books for now
import { RowsPhotoAlbum } from "react-photo-album";
import "react-photo-album/rows.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const photos = [
  { src: "images/gallery/book1/van_lilim_1.jpg", width: 430, height: 961 },
  { src: "images/gallery/book1/Van1.jpg", width: 542, height: 961 },
  { src: "images/gallery/book1/Shale1.jpg", width: 542, height: 961 },
  { src: "images/gallery/book1/Galdur1.jpg", width: 447, height: 958 },
  { src: "images/gallery/book1/Lilim1.jpg", width: 500, height: 562 },
  
];

export default function Gallery() {

  const [index, setIndex] = React.useState(-1);

  return <section className="gallery" id="gallery">
    <div className="gallerycontent" id="gallery-content">
      <p className="body_text"><strong>For a limited time, enjoy a preview of the art for Children of Nemia</strong></p>
    <RowsPhotoAlbum
      onClick={({ index: current }) => setIndex(current)}
      photos={photos}
      // targetRowHeight={400}
      rowConstraints={{ singleRowMaxHeight: 400 }} // only available with RowsPhotoAlbum; doesn't seem to work with MasonryPhotoAlbum
    />

    <Lightbox
      index={index}
      slides={photos}
      open={index >= 0}
      close={() => setIndex(-1)}
      render={{ buttonPrev: () => null, buttonNext: () => null }}
      carousel={{ finite: true }}
      styles={{ root: { "--yarl__color_backdrop": "rgba(0, 0, 0, .8)" } }}
      controller={{ closeOnBackdropClick: true, closeOnPullUp: true, closeOnPullDown: true }}
    />
    </div>
  </section>

}
